import { EffectReducer } from 'use-effect-reducer';
import {
  EffectSingleDateRangePicker,
  EventSingleDateRangePicker,
  StateSingleDateRangePicker
} from './types';

export const dateRangeReducer: EffectReducer<
  StateSingleDateRangePicker,
  EventSingleDateRangePicker,
  EffectSingleDateRangePicker
> = (state, action, exec) => {
  // console.log('action', action);

  switch (action.type) {
    case 'SET_DATE_ACTION': {
      exec(action);
      return {
        ...state,
        selectedRange: new Set(action.payload),
        currentDate: new Set(action.payload),

        focusSelectedDay: false,
        valid: true
      };
    }
    case 'CHANGE_DATES': {
      exec(action);
      return {
        ...state,
        currentDate: state.selectedRange
      };
    }
    case 'SELECT_DAY_ACTION': {
      const pickedDate = action.payload;
      const dateTime = pickedDate.getTime();
      const newSelectedRange = new Set(state.selectedRange);
      if (state.selectedRange.has(dateTime)) {
        newSelectedRange.delete(dateTime);
      } else {
        newSelectedRange.add(dateTime);
      }

      exec(action);
      return {
        ...state,
        valid: true,
        selectedRange: newSelectedRange
      };
    }
    case 'CLEAR_ACTION': {
      exec(action);
      return {
        ...state,
        preSelected: undefined,
        selectedRange: new Set(),
        focusSelectedDay: false,
        valid: true
      };
    }
    case 'SET_MONTHS': {
      return {
        ...state,
        months: action.payload
      };
    }
    case 'SET_VALID': {
      return {
        ...state,
        valid: action.payload
      };
    }
    case 'SET_PRESELECTED_DATE': {
      return {
        ...state,
        valid: true,
        preSelected: action?.payload
      };
    }
    case 'SET_FOCUS_SELECTED_DAY': {
      return {
        ...state,
        focusSelectedDay: action.payload
      };
    }
    case 'SET_DISPLAY_DATE_ACTION': {
      exec(action);
      return {
        ...state,
        displayDate: action.payload
      };
    }
    case 'CHANGE_CURRENT_MONTH': {
      return {
        ...state,
        currentMonth: action.payload
      };
    }
    case 'OPEN_POPOVER_ACTION':
    case 'CLOSE_POPOVER_ACTION': {
      exec(action);
      return state;
    }
    case 'SET_POPOVER': {
      return {
        ...state,
        popoverOpen: action.payload.popoverOpen,
        focusSelectedDay: action.payload.focusSelectedDay
      };
    }
    case 'CANCEL_ACTION': {
      exec(action);
      return {
        ...state,
        focusSelectedDay: false
      };
    }
    default:
      return state;
  }
};
